// Coming-soon page body for honest service-not-configured states, such as PKI
// when device-CA is absent.

export function ComingSoon({ title, detail }: { title: string; detail: string }) {
  return (
    <>
      <div className="page-header">
        <div>
          <h1 className="page-title">
            {title} <span className="soon-badge" style={{ verticalAlign: 'middle' }}>即將開放</span>
          </h1>
          <p className="page-subtitle">{detail}</p>
        </div>
      </div>
      <div className="card">
        <div className="state-block" style={{ padding: 'var(--spacing-20)' }}>
          <div className="state-title">此功能尚未在目前環境啟用</div>
          <div className="state-detail">{detail}</div>
        </div>
      </div>
    </>
  );
}
